var map = {
	"./Abu.jpg": 8000,
	"./Abu_start.jpg": 9745,
	"./Baboon.jpg": 4477,
	"./Baboon_start.jpg": 1765,
	"./Bagheera.jpg": 347,
	"./Bagheera_start.jpg": 2386,
	"./Baloo.jpg": 2815,
	"./Baloo_start.jpg": 4997,
	"./Bonobo.jpg": 2941,
	"./Bonobo_start.jpg": 5869,
	"./Boulder-all.jpg": 3527,
	"./Boulder-girl.jpg": 9448,
	"./Boulder-start.jpg": 7501,
	"./Caesar.jpg": 7923,
	"./Caesar_start.jpg": 922,
	"./Charly.jpg": 1198,
	"./Charly_start.jpg": 1236,
	"./Cheeta.jpg": 1542,
	"./Cheeta_start.jpg": 9163,
	"./Chimpanzee.jpg": 4820,
	"./Chimpanzee_start.jpg": 2966,
	"./Coconut.jpg": 8292,
	"./Coconut_start.jpg": 2711,
	"./DrDolittle.jpg": 5785,
	"./DrDolittle_start.jpg": 1064,
	"./Gibbon.jpg": 982,
	"./Gibbon_start.jpg": 9228,
	"./Gorilla.jpg": 2223,
	"./Gorilla_start.jpg": 5957,
	"./Hathi.jpg": 1826,
	"./Hathi_start.jpg": 3471,
	"./Jane.jpg": 7011,
	"./Jane_start.jpg": 8838,
	"./Kaa.jpg": 8834,
	"./Kaa_start.jpg": 7286,
	"./Kala.jpg": 1687,
	"./Kala_start.jpg": 7924,
	"./Katta.jpg": 465,
	"./Katta_start.jpg": 6117,
	"./King_Kong.jpg": 230,
	"./King_Kong_start.jpg": 81,
	"./King_Louie.jpg": 793,
	"./King_Louie_start.jpg": 3164,
	"./Lemur.jpg": 6895,
	"./Lemur_start.jpg": 2612,
	"./Macaque.jpg": 7070,
	"./Macaque_start.jpg": 3588,
	"./Mowgli.jpg": 8550,
	"./Mowgli_start.jpg": 3613,
	"./Ocean_Wave.jpg": 702,
	"./Ocean_Wave_start.jpg": 6213,
	"./Orang-Utan.jpg": 4649,
	"./Orang-Utan_start.jpg": 8905,
	"./ProfilePic.jpg": 5495,
	"./Shere_Khan.jpg": 3431,
	"./Shere_Khan_start.jpg": 1204,
	"./Tarzan.jpg": 8890,
	"./Tarzan_start.jpg": 4439,
	"./Test.jpg": 195,
	"./Test_start.jpg": 6786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;